var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { name: "step2" } },
    [
      _c("StepBox", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "terms-box bottom-xl" },
        [
          _c("i18n", {
            attrs: {
              tag: "h5",
              path: "demo.demoRegistration.step2.checkboxes.facialRegistrationAndVerificationPurposes",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card-box" }, [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "demo.demoRegistration.step2.facialRegistrationAndVerificationPurposes.row1"
                    )
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "terms-box bottom-xl" }, [
        _c("div", { staticClass: "form-check form-check-lg" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.agreement,
                expression: "agreement",
              },
            ],
            attrs: { id: "check-111", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.agreement)
                ? _vm._i(_vm.agreement, null) > -1
                : _vm.agreement,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.agreement,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.agreement = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.agreement = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { attrs: { for: "check-111" } },
            [
              _c("i18n", {
                attrs: {
                  tag: "span",
                  path: "demo.demoRegistration.step2.checkboxes.personalInformationCollectionAndUsageAgreement",
                },
                scopedSlots: _vm._u([
                  {
                    key: "mandatory",
                    fn: function () {
                      return [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "demo.demoRegistration.step2.checkboxes.mandatory"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-box" }, [
          _c(
            "p",
            [
              _c("i18n", {
                attrs: {
                  path: "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.row1",
                },
                scopedSlots: _vm._u([
                  {
                    key: "companyName",
                    fn: function () {
                      return [_vm._v(_vm._s(_vm.companyName))]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.row2"
                    )
                  ) +
                  "\n      "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("table", { staticClass: "table" }, [
            _c("caption", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t(
                      "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.title"
                    )
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("thead", [
              _c("tr", [
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t(
                          "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.th1"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t(
                          "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.th2"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  { staticStyle: { width: "177px" }, attrs: { scope: "col" } },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.th3"
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t(
                          "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td1"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("ul", { staticClass: "bull" }, [
                    _c("li", [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$t(
                              "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td2"
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$t(
                              "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td2-1"
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "strong-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "demo.demoRegistration.step2.personalInformationCollectionAndUsageAgreement.table.td3"
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }